import React from 'react';
import { Line } from 'react-chartjs-2';
var WinrateLineChartMini = function (_a) {
    var _b, _c;
    var allyTeam = _a.allyTeam, snapshots = _a.snapshots, winrates = _a.winrates, maxTime = _a.maxTime;
    var blueLine = 'rgba(0, 163, 240)';
    var redLine = 'rgba(230, 10, 20, 0.8)';
    var lineColor = allyTeam === 'blue' ? blueLine : redLine;
    var data = {
        labels: snapshots.map(function (snapshot) { return snapshot.time; }),
        datasets: [
            {
                label: 'Winrate',
                data: winrates,
                borderColor: lineColor,
                borderWidth: 2,
                pointRadius: 0,
                hoverRadius: 0,
            },
        ],
    };
    var options = {
        responsive: true,
        maintainAspectRatio: false,
        animation: false,
        events: [],
        layout: {
            padding: {
                top: 0,
                bottom: 0,
                left: 0,
                right: 0,
            },
        },
        scales: {
            x: {
                type: 'linear',
                min: (_c = (_b = snapshots[0]) === null || _b === void 0 ? void 0 : _b.time) !== null && _c !== void 0 ? _c : 0,
                beginAtZero: false,
                max: maxTime,
                ticks: {
                    display: false,
                },
                grid: {
                    display: false,
                },
            },
            y: {
                beginAtZero: false,
                min: 0,
                max: 100,
                title: {
                    display: false,
                },
                ticks: {
                    display: false,
                },
                grid: {
                    display: true,
                    color: function (context) {
                        if (context.tick.value === 0 || context.tick.value === 100) {
                            return 'rgba(255, 255, 255, 0.1)';
                        }
                    }
                },
            },
        },
        plugins: {
            legend: {
                display: false,
            },
            title: {
                display: false,
            },
            tooltip: {
                enabled: false,
            },
            crosshair: false,
            lineChartIcons: {
                enabled: false,
            },
            barChartLabelIcons: {
                enabled: false,
            },
            barChartMiniLabelIcons: {
                enabled: false,
            },
            zoom: false,
        },
    };
    return (React.createElement("div", { style: { height: '100%', width: '100%' } },
        React.createElement(Line, { data: data, options: options })));
};
export default WinrateLineChartMini;
